import React from 'react'
import {useEffect, useState} from 'react'

import {logger} from '@vio/core/src/utils/logging/logger'
import {urlHasParam} from '@vio/core/src/utils/url'

import {getPersistedSimulationFlag} from '.'

export const ScenarioSimulatorDeferredLoader = ({
  children,
  initializer,
  shouldLoadSimulator
}: {
  children: React.ReactNode
  initializer: () => Promise<{default: () => Promise<void>}>
  // Temporary flag to bail out of SSR if simulator should be loaded.
  shouldLoadSimulator?: boolean
}) => {
  const [isSimulatorLoaded, setIsSimulatorLoaded] = useState(false)

  const isSSR = typeof window === 'undefined'

  // During SSR, trust flag from props. During client-side, check for URL param or cookie.
  const loadSimulatorClientSide = isSSR
    ? shouldLoadSimulator
    : urlHasParam({search: window.location.search, param: 'simulate'}) ||
      getPersistedSimulationFlag()

  useEffect(() => {
    async function loadSimulator() {
      try {
        if (loadSimulatorClientSide && initializer && !isSimulatorLoaded) {
          console.log(
            '⚙️ Simulator required (either via URL param or cookie) - loading simulator module...'
          )
          const module = await initializer()
          await module.default()
          console.log(
            '⚙️ Simulator module loaded and ready to intercept network requests'
          )
          setIsSimulatorLoaded(true)
        }
      } catch (error) {
        logger.error('Error loading simulator module', error)
        setIsSimulatorLoaded(true)
      }
    }
    loadSimulator()
  }, [loadSimulatorClientSide, initializer, isSimulatorLoaded])

  //We only block rendering when there's a need to load the simulator
  //This is needed to prevent network queries to run before the simulator is initialised
  if (!loadSimulatorClientSide || isSimulatorLoaded) {
    return <>{children}</>
  }

  return null
}
